var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-content"},[_c('button',{staticClass:"getstart w-btn us-btn-style_1",attrs:{"type":"button"},on:{"click":_vm.startQuiz}},[_c('span',{staticClass:"w-btn-label"},[_vm._v("Get Started")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }